import {container} from "tsyringe";
import {ICommand} from "../commands/i-command.interface";
import {CommandBus} from "../services/command-bus.service";
import {ClassOf} from "../types/class-of.type";

export function Command<T extends Object>(options: { type: string, prototype: ClassOf<T> }) {

    return function (commandPrototype: ClassOf<ICommand>): void {
        container.resolve(CommandBus).registerCommand<T>(options.prototype, options.type, commandPrototype);
    }
}